import { useQuery } from "@tanstack/react-query";
import Table from "../common/Table";
import Button from "../common/Button";
import { teamService } from "../../services/team";

const MemberList = ({ onEdit, onDelete }) => {
  const { data: members, isLoading } = useQuery({
    queryKey: ["team"],
    queryFn: teamService.getAll,
  });

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Email", accessor: "email" },
    { header: "Role", accessor: "role" },
  ];

  if (isLoading) return <div>Loading...</div>;

  return (
    <Table
      columns={columns}
      data={members}
      actions={
        onEdit || onDelete
          ? (row) => (
              <div className="flex gap-2 justify-end">
                {onEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
                {onDelete && (
                  <Button
                    variant="danger"
                    onClick={() => {
                      if (window.confirm("Are you sure you want to delete this member?")) {
                        onDelete(row._id);
                      }
                    }}
                  >
                    Delete
                  </Button>
                )}
              </div>
            )
          : null
      }
    />
  );
};

export default MemberList;
